import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["offsetBottom", "offsetTop", "children"];
import { useContext, useEffect, useRef } from 'react';
import { DialogContext } from '../Dialog/DialogContext';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const GRID_BREAKPOINT_SMALL = '544px';
const StyledHeaderImage = styled.div.withConfig({
  displayName: "DialogHeaderImage__StyledHeaderImage",
  componentId: "sc-1wiqfg6-0"
})(({
  theme
}) => {
  return {
    display: 'flex',
    marginBottom: theme.space['1000'],
    marginInline: 'auto',
    textAlign: 'center',
    [`@media only screen and (max-width: ${GRID_BREAKPOINT_SMALL})`]: {
      marginBlockStart: 'auto !important'
    }
  };
});
export const DialogHeaderImage = _ref => {
  let {
      offsetBottom,
      offsetTop,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const {
    headerCallback
  } = useContext(DialogContext);
  const elRef = useRef(null);
  useEffect(() => {
    const updateHeaderOffset = () => {
      // Measuring offsetTop in the DOM is more accurate than using the offsetTop prop, because it
      // accounts for the padding above the element.
      if (!elRef.current) return;
      //@ts-expect-error Modal migration
      const overflow = -1 * elRef.current.offsetTop;
      if (overflow > 0) {
        if (headerCallback) headerCallback(overflow);
      }
    };
    updateHeaderOffset();
    window.addEventListener('resize', updateHeaderOffset);
    return () => {
      window.removeEventListener('resize', updateHeaderOffset);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsx(StyledHeaderImage, Object.assign({}, domProps, {
    ref: elRef,
    style: Object.assign({
      marginBottom: offsetBottom,
      marginTop: offsetTop != null ? offsetTop * -1 : undefined
    }, cssStyles),
    children: children
  }));
};
DialogHeaderImage.displayName = 'DialogHeaderImage';